
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/history",
      function () {
        return require("private-next-pages/search/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/history"])
      });
    }
  